import { ProviderAuthenticationCommon } from '~/plugins/data-connector/authentication/common'

export const ProviderSqlCommon = {
  key: 'sql',
  authentication: ProviderAuthenticationCommon.Form(),
}

export type ProviderSqlAccountType = {
  input: {
    name: string
    url: string
  }
}

export type RowType = { [columnName: string]: any }
